import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GlobeIcon } from 'lucide-react';
export function LanguageSwitcher() {
  const {
    i18n
  } = useTranslation();
  const [currentLang, setCurrentLang] = useState(i18n.language);
  useEffect(() => {
    const handleLanguageChange = (lng: string) => {
      setCurrentLang(lng);
    };
    i18n.on('languageChanged', handleLanguageChange);
    setCurrentLang(i18n.language);
    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [i18n]);
  const languages = [{
    code: 'en',
    name: 'EN'
  }, {
    code: 'es',
    name: 'ES'
  }, {
    code: 'fr',
    name: 'FR'
  }, {
    code: 'ca',
    name: 'CA'
  }];
  return <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2" data-id="element-65">
      <GlobeIcon className="w-4 h-4 text-white" data-id="element-66" />
      {languages.map(lang => <button key={lang.code} onClick={() => i18n.changeLanguage(lang.code)} className={`px-3 py-1 rounded-full text-sm font-medium transition-all ${currentLang === lang.code ? 'bg-white text-blue-600' : 'text-white hover:bg-white/20'}`} data-id="element-67">
          {lang.name}
        </button>)}
    </div>;
}